import { rankOf, type CardId } from '@basgan/rules';

/**
 * Elde kart seçimi.
 *
 * Bu oyunda bir hamle YALNIZCA aynı rütbeden kartlardan oluşur (tekli, ikili,
 * üçlü, dörtlü). Bu yüzden karışık bir seçimin oluşmasına hiç izin vermiyoruz:
 * farklı rütbeye dokunmak "fikir değiştirdim" demektir, seçim oraya taşınır.
 *
 * Alternatif olan "karışık seçime izin ver, sonra 'at' düğmesini kilitle"
 * yaklaşımı kullanıcıya neyin yanlış olduğunu söylemiyordu.
 */
export function toggleSelection(current: readonly CardId[], card: CardId): CardId[] {
  if (current.includes(card)) return current.filter((c) => c !== card);
  if (current.length > 0 && rankOf(current[0]!) !== rankOf(card)) return [card];
  return [...current, card];
}

/**
 * DEĞİŞİM için seçim — aynı rütbe kuralı YOK.
 *
 * `toggleSelection` bu iş için kullanılıyordu ve hataydı: rütbe kısıtı hamleye
 * ait, değişime değil. 3♦ seçip 7♣'ye dokununca seçim sıfırlanıyor, iki farklı
 * kart hiç seçilemiyordu — yani 1. olup 2 kart vermesi gereken oyuncu kilitli
 * kalıyordu.
 *
 * Kota dolduğunda en eski seçim düşüyor: üçüncü karta dokunmak "hiçbir şey
 * olmadı" yerine "fikrini değiştirdin" anlamına geliyor.
 */
export function toggleExchange(
  current: readonly CardId[],
  card: CardId,
  max: number,
): CardId[] {
  if (current.includes(card)) return current.filter((c) => c !== card);
  if (max <= 0) return [];
  if (current.length >= max) return [...current.slice(current.length - max + 1), card];
  return [...current, card];
}
